import { BDE_APP_CONFIG } from "..";

export class ConfigProvider {
  private _config: BDE_APP_CONFIG;

  constructor(defaultConfig) {
    this._config = defaultConfig;
  }

  public get config(): BDE_APP_CONFIG {
    return this._config;
  }

  public set config(v: BDE_APP_CONFIG) {
    this._config = v;
  }
}
